import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Gộp className có điều kiện + xử lý xung đột Tailwind.
 * Dùng ở mọi component thay cho việc nối chuỗi thủ công.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
